import { Observable } from "rxjs";
import { Credentials } from "@app/core/shared/domain/credentials";
import { LoginResponse } from "@app/core/user/domain/login.reponse";

/**
 * Service used to log in.
 */
export abstract class LoginService {
  abstract execute(credentials: Credentials): Observable<LoginResponse>;
}
